import styled, { keyframes } from "styled-components";
import { MdArrowBack } from "react-icons/md";
import { TextM } from "../../common/text";
import { TextField } from "@mui/material";

export const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 3px;
  position: fixed;
  width: 100%;
  height: 60px;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: white;
`;

const textLoop = keyframes`
  0% {
    transform: translate3d(50%, 0, 0);
  }
  100% {
    transform: translate3d(-100%, 0, 0);
  }
`;

export const HeaderTextWrapper = styled.div`
  width: 80%;
  display: flex;
  flex: 0 0 auto;
  white-space: nowrap;
  overflow: hidden;
`;

export const HeaderAnimationText = styled(TextM)`
  animation: ${textLoop} 12s linear infinite;
  padding-right: 1.5vw;
`;

export const HeaderText = styled(TextM)`
  @media ${({ theme }) => theme.device.iphoneMini} {
    font-size: 16px;
  }
`;

export const ArrowBackIcon = styled(MdArrowBack)`
  color: black;
  font-size: 6vw;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 35px;
  }
  @media ${({ theme }) => theme.device.laptop} {
    font-size: 35px;
  }
  position: fixed;
  left: 10px;
`;
